import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const location = useLocation();

  const isHome = location.pathname === '/';

  return (
    <nav style={styles.nav}>
      <Link to="/" style={styles.logoLink}>
        <h1 style={styles.logo}>Hungry King</h1>
      </Link>
      <div style={styles.linksContainer}>
        {!isHome && <Link to="/" style={styles.link}>Home</Link>}
        <Link to="/menu" style={styles.link}>Menu</Link>
        <Link to="/checkout" style={styles.link}>Checkout</Link>
      </div>
    </nav>
  );
}

const styles = {
  nav: {
    backgroundColor: '#03045e',
    color: 'white',
    padding: '1rem 2rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    boxShadow: '0 2px 10px rgba(0,0,0,0.4)'
  },
  logoLink: {
    textDecoration: 'none',
    color: '#d4af37', // gold accent
  },
  logo: {
    fontSize: '1.8rem',
    fontWeight: 'bold',
    margin: 0,
  },
  linksContainer: {
    display: 'flex',
    gap: '1.5rem',
  },
  link: {
    color: '#fff',
    textDecoration: 'none',
    fontSize: '1rem',
    fontWeight: 500,
    padding: '0.5rem 1rem',
    borderRadius: '8px',
    transition: 'all 0.3s ease',
  },
  linkHover: {
    backgroundColor: '#d4af37',
    color: '#001d4a',
  }
};
